/**
 * Schema of TipoPessoaRecebedor
 * @author Simpli CLI generator
 */
import {InputType, Schema} from 'simpli-web-sdk'
import {bool} from 'simpli-web-sdk'
import TipoPessoaRecebedor from '@/model/resource/TipoPessoaRecebedor'

export default (model: TipoPessoaRecebedor): Schema => ({
  idTipoPessoaPk: {
    content: model.idTipoPessoaPk,
    editable: false,
  },

  nome: {
    content: model.nome,
    input: InputType.TEXT,
    meta: {
      required: true,
      maxlength: '255',
    },
  },

    ativo: {
        content: bool(model.ativo),
        input: InputType.CHECKBOX,
    },

    nomeAlt: {
        model: 'nome',
        content: model.nome,
        textContent: null,
        input: InputType.TEXT,
        meta: {
            required: true,
            maxlength: '255',
        },
    },
})
